import Image from 'next/image';
import classNames from 'classnames';
import { Button, ButtonThemes, ButtonSize } from '@app/shared';
import { useRouter } from 'next/router';

import styles from './errorTemplate.module.scss';

interface IProps {
  className?: string;
  message?: string;
  messageData?: object;
  text?: string;
}

export const ErrorTemplate = ({ className, text }: IProps) => {
  const router = useRouter();

  const handlerReloadPage = () => {
    router.reload();
  };

  return (
    <div className={classNames(styles.Wrapper, className)}>
      <div className={styles.Container}>
        <p>Мы уже работаем над устранением проблемы</p>
        <div className={styles.WrapperImage}>
          <Image src="/next/gimg/error_code/error.svg" alt="code_error" width={774} height={315} layout="responsive" />
        </div>
        <div className={styles.Text}>{text}</div>
        <Button className={styles.Btn} themes={ButtonThemes.Secondary} size={ButtonSize.S} fullWith onClick={handlerReloadPage}>
          Перезагрузить страницу
        </Button>
      </div>
    </div>
  );
};
